import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  plugins: {
    title: {
      display: false,
    },
    legend: {
      position: "bottom",
    },
  },
  responsive: true,
  scales: {
    x: {
      stacked: true,
    },
    y: {
      stacked: true,
      ticks: {
        callback: function (label, index, labels) {
          return (label / 1000000000).toLocaleString() + " M";
        },
      },
    },
  },
  maintainAspectRatio: false,
};

export default function RealisasiBulanan({
  tahun,
  setTahun,
  epnbp,
  kerjasamabu,
  jasaperbankan,
  pendapatanlainlain,
}) {
  const labels = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Mei",
    "Jun",
    "Jul",
    "Agu",
    "Sep",
    "Okt",
    "Nov",
    "Des",
  ];
  let datasets = [
    {
      label: "KPU/USO",
      data: [],
      backgroundColor: "rgb(92, 184, 93)",
    },
    {
      label: "Kerjasama BU",
      data: [],
      backgroundColor: "rgb(48, 180, 242)",
    },
    {
      label: "Perbankan",
      data: [],
      backgroundColor: "rgb(255, 71, 30)",
    },
    {
      label: "Pendapatan Lain-lain",
      data: [],
      backgroundColor: "rgb(250, 159, 71)",
    },
  ];
  if (
    epnbp === Object(epnbp) &&
    kerjasamabu === Object(kerjasamabu) &&
    jasaperbankan === Object(jasaperbankan) &&
    pendapatanlainlain === Object(pendapatanlainlain)
  ) {
    Object.entries(epnbp).map(([key, value], i) => {
      datasets[0].data.push(value);
      datasets[1].data.push(Object.entries(kerjasamabu)[i][1]);
      datasets[2].data.push(Object.entries(jasaperbankan)[i][1]);
      datasets[3].data.push(Object.entries(pendapatanlainlain)[i][1]);

      return datasets;
    });
  }

  const data = {
    labels,
    datasets: datasets,
  };

  const thisYear = new Date().getFullYear();

  const increaseTahun = () => {
    if (tahun + 1 <= thisYear) {
      setTahun((inputTahun) => inputTahun + 1);
    }
  };

  const decreaseTahun = () => {
    if (tahun > 2018) {
      setTahun((inputTahun) => inputTahun - 1);
    }
  };

  return (
    <>
      <div className="bg-primary-second rounded-t-lg px-8 py-6 grid grid-cols-1 md:grid-cols-2">
        <div className="self-center">
          <h3 className="text-base md:text-xl font-semibold text-white">
            Realisasi Penerimaan Perbulan
          </h3>
        </div>
        <div className="self-center mt-2 md:mt-0">
          <div className="flex flex-row justify-center md:justify-end">
            <button
              onClick={decreaseTahun}
              type="button"
              className="px-2 md:px-3 py-1 md:py-2 mr-2 last:mr-0 bg-primary-second text-white rounded-lg border border-neutral-300 hover:bg-primary-main duration-300"
            >
              <svg
                className="w-4 md:w-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </button>

            <p className="flex-1 md:flex-none mr-2 last:mr-0 p-1 md:p-2 text-center text-sm md:text-base bg-primary-second text-white rounded-lg border border-neutral-300 hover:bg-primary-main duration-300">
              {tahun}
            </p>

            <button
              onClick={increaseTahun}
              type="button"
              className="px-2 md:px-3 py-1 md:py-2 mr-2 last:mr-0 bg-primary-second text-white rounded-lg border border-neutral-300 hover:bg-primary-main duration-300"
            >
              <svg
                className="w-4 md:w-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div className="p-8 h-80 md:h-96">
        <Bar options={options} data={data} />
      </div>
    </>
  );
}
